import React, { useState,useEffect } from "react";
import "./LoginPage.css";
import { useNavigate } from "react-router-dom";
import {useMsal} from "@azure/msal-react";

const LoginPage = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const { instance } = useMsal();
   useEffect(() => {
    const acct = instance.getActiveAccount();
      if (acct) navigate("/dashboard");
  }, [instance, navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Use MSAL instead of local credential check
   // const response = await instance.loginPopup({ scopes: ["openid", "profile", "email"] });
   // instance.setActiveAccount(response.account);
    //if (userId === "admin" && password === "1234") {
   //   navigate("/landing-page");
  //}
    const loginRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    instance.loginRedirect(loginRequest);
  };



  return (
    <div className="login-container">
      <div className="login-content">
        <div className="login-left">
          <h2>Supplier Forecast Collaboration</h2>
          <p className="account-text">Account Sign In</p>
        </div>
        <div className="divider"></div>
        
        <form className="login-box" onSubmit={handleSubmit}>
          <div className={`input-container ${userId ? "focused" : ""}`}>
            <input
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              onFocus={(e) => e.target.parentNode.classList.add("focused")}
              onBlur={(e) => {
                if (!userId) e.target.parentNode.classList.remove("focused");
              }}
            />
            <label>User ID</label>
          </div>

          <div className={`input-container ${password ? "focused" : ""}`}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={(e) => e.target.parentNode.classList.add("focused")}
              onBlur={(e) => {
                if (!password) e.target.parentNode.classList.remove("focused");
              }}
            />
            <label>Password</label>
          </div>

          <p className="terms">
            Clicking on Sign On indicates acceptance of{" "}
            <a href="#">Terms and Conditions</a>
          </p>

          <button className="signon-btn" type="submit">
            Sign On
          </button>

          <p className="reset-text">
            For resetting password or managing account{" "}
            <a href="#">click here</a>
          </p>
        </form>
      </div>
    </div>
  );

};
export default LoginPage;